import { createLoaderImp } from '../../../../components/ozmoit/common/loader-imp';
import { getStudentActionsAction } from '../actions/studentActionsActions';

const {
  useLoader: useStudentActionsLoader,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getStudentActionsAction,
});

function StudentActionsLoader({
  children,
  ...props
}: Readonly<Parameters<typeof LoaderProvider>[0]>) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export { StudentActionsLoader, useStudentActionsLoader };
